/* eslint-disable max-len */
import { FC, ReactElement } from 'react';

import { SvgFlagProps } from '../Flag';

import '../Flag.scss';

const FlagEN: FC<SvgFlagProps> = ({ className = '' }): ReactElement => {
    const colors = {
        royalBlue: '#012169',
        white: '#ffffff',
        red: '#c8102e',
    };

    return (
        <svg viewBox="0 0 200 100" className={`flag ${className}`}>
            <path fill={colors.royalBlue} d="M0,0v100h200V0H0z" />
            <polygon fill={colors.white} points="200,11.2 200,0 177.6,0 116.7,30.5 116.7,0 83.3,0 83.3,30.5 22.4,0 0,0 0,11.2 44.3,33.3 0,33.3 0,66.7 44.3,66.7 0,88.8 0,100 22.4,100 83.3,69.5 83.3,100 116.7,100 116.7,69.5 177.6,100 200,100 200,88.8 155.7,66.7 200,66.7 200,33.3 155.7,33.3" />
            <polygon fill={colors.red} points="110,100 90,100 90,60 0,60 0,40 90,40 90,0 110,0 110,40 200,40 200,60 110,60" />
            <polygon fill={colors.red} points="66.7,66.7 0,100 14.9,100 81.6,66.7" />
            <polygon fill={colors.red} points="148.2,66.7 133.3,66.7 200,100 200,92.5" />
            <polygon fill={colors.red} points="133.3,33.3 200,0 185.1,0 118.4,33.3" />
            <polygon fill={colors.red} points="66.7,33.3 0,0 0,7.5 51.8,33.3" />
        </svg>
    );
};

export default FlagEN;
/* eslint-enable max-len */
